import React from 'react';
import Text from '../../../../../Components/Base/Text/Text';

interface Props {
  value: string[]
}

const ElectronicPrescriptionDailyDosageFixed: React.FC<Props> = props => {
  const { value } = props;

  return (
    <>
      <Text tx={'nczi.electronicPrescription.detail.dosage.daily.fixed.morning'} inline />: {value[0]},&nbsp;
      <Text tx={'nczi.electronicPrescription.detail.dosage.daily.fixed.lunch'} inline />: {value[1]},&nbsp;
      <Text tx={'nczi.electronicPrescription.detail.dosage.daily.fixed.evening'} inline />: {value[2]},&nbsp;
      <Text tx={'nczi.electronicPrescription.detail.dosage.daily.fixed.night'} inline />: {value[3]}
    </>
  );
};

export default ElectronicPrescriptionDailyDosageFixed;